var img = "data:image/svg+xml,%3csvg width='46' height='32' viewBox='0 0 46 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect x='8' y='10' width='29.3333' height='12' rx='1' fill='%237D7D7D' /%3e%3c/svg%3e";
  var PbSliderOneRowFilled = img;

export { PbSliderOneRowFilled as default };
